import React from "react";

import type { AssociatedPitchedContent } from "../../../../store/editContent";
import { getPitchedContentDetails } from "../../../../utils/pitchedContentDetails.utils";
import { CardLayout } from "../insightDetails/CardLayout";

import { PitchedContentCardAction } from "./PitchedContentCardAction";

export interface PitchedContentCardProps {
    content: AssociatedPitchedContent;
    key: string;
    isEditable: boolean;
    isSharable: boolean;
}

export const PitchedContentCard: React.FunctionComponent<
    PitchedContentCardProps
> = ({ key, content, isEditable, isSharable }) => {
    const pitchedContentDetails = getPitchedContentDetails(content);

    return (
        <CardLayout
            key={key}
            dataTestId={`pitched-${content.contentId}`}
            details={pitchedContentDetails}
            description={content.contentTitle ?? ""}
            actions={
                <PitchedContentCardAction
                    content={content}
                    details={pitchedContentDetails}
                    isEditable={isEditable}
                    isSharable={isSharable}
                />
            }
        />
    );
};
